import { render } from "./404.vue?vue&type=template&id=4cd877cc&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=4cd877cc&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd877cc"]])

export default __exports__